export { default } from './getThemeProps';